import { ChangeDetectionStrategy, Component, inject, input, OnInit, output, signal } from '@angular/core';
import { StorageKey, StorageService } from '@nk/storage-lib';
import { includes } from '@nk/utils-lib';

@Component({
  selector: 'nk-dismissable-alert-message',
  templateUrl: './dismissable-alert-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DismissableAlertMessageComponent implements OnInit {
  public localStorageKey = input<string>();
  public alertColor = input('info');
  public andClass = input('');
  public persistInLocalStorage = input(true);
  public dismissed = output<void>();
  public showMessage = signal(true);

  private _storageService = inject(StorageService);
  private _storageKey: StorageKey = 'message_box.closed_keys';
  private _closedMessageBoxes: string[] = [];

  public ngOnInit(): void {
    const key = this.localStorageKey();
    if (key && this.persistInLocalStorage()) {
      const closedMessageBoxes = this._storageService.getItem(this._storageKey);
      if (Array.isArray(closedMessageBoxes)) {
        this._closedMessageBoxes = closedMessageBoxes as string[];
        if (includes(this._closedMessageBoxes, key)) {
          this.showMessage.set(false);
        }
      }
    }
  }

  public closeButton(): void {
    this.showMessage.set(false);
    this.dismissed.emit();
    const key = this.localStorageKey();
    if (key && this.persistInLocalStorage()) {
      this._closedMessageBoxes.push(key);
      this._storageService.setItem(this._storageKey, this._closedMessageBoxes);
    }
  }
}
